import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Loginwithfayda from './components/AuthFayda';
import Register from './components/Registeration';
import { AuthProvider, useAuth } from './components/AuthContext';
import theme from './theme'; // Adjust this import according to where your theme is defined
import ForgotUsername from './components/ForgotUsename';
import UpdatePreference from './components/UpdatePreferencePage';
import Verify from './components/Verify';
import UserVerification from './components/UserVerification';
import './index.css';

<Route path="/forgot-username" element={<ForgotUsername />} />

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}


function AppContent() {
  const { authStatus } = useAuth();

  return (
    <Routes>
       
          <Route path="/" element={<Navigate replace to="/registration" />} />
          <Route path="/registration" element={<Register />} />
          <Route path="*" element={<Navigate to="/registration" />} />
          <Route path="/authfayda" element={<Loginwithfayda />} />
          <Route path="/callback" element={<Navigate replace to="/registration" />} />
          <Route path="/update-preference" element={<UpdatePreference />} />
          <Route path="/forgot-username" element={<ForgotUsername />} />
          <Route path="/verify-test-api-token" element={<Verify />} />
          <Route path="/verify/:userId" element={<UserVerification />} />


    </Routes>
  );
}

export default App;
